import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';
import { Card, CardContent } from '../ui/card';

export interface TestimonialEntry {
  quote: string;
  author: string;
  role?: string;
  caseStudySlug?: string;
}

export interface TestimonialsProps {
  title?: string;
  testimonials: TestimonialEntry[];
}

export function Testimonials({ title, testimonials }: TestimonialsProps) {
  if (testimonials.length === 0) return <></>;
  return (
    <section className="bg-white py-16">
      <Container>
        {title ? <h2 className="mb-10 text-3xl font-bold">{title}</h2> : null}
        <div className="grid gap-6 lg:grid-cols-3">
          {testimonials.map((t) => (
            <Card key={t.author}>
              <CardContent className="p-6">
                <blockquote className="text-stone-800">« {t.quote} »</blockquote>
                <p className="mt-4 text-sm font-semibold text-stone-900">{t.author}</p>
                {t.role ? <p className="text-xs text-stone-500">{t.role}</p> : null}
                {t.caseStudySlug ? (
                  <a
                    href={`/cas-clients/${t.caseStudySlug}`}
                    className="mt-3 inline-block text-sm font-semibold text-brand-700 hover:underline"
                  >
                    Lire le cas client →
                  </a>
                ) : null}
              </CardContent>
            </Card>
          ))}
        </div>
        <p className="mt-8 text-xs text-stone-500">
          Témoignages issus exclusivement de cas clients réels documentés et signés.
        </p>
      </Container>
    </section>
  );
}

export const TestimonialsConfig: ComponentConfig<TestimonialsProps> = {
  fields: {
    title: { type: 'text' },
    testimonials: {
      type: 'array',
      arrayFields: {
        quote: { type: 'textarea' },
        author: { type: 'text' },
        role: { type: 'text' },
        caseStudySlug: { type: 'text' },
      },
      defaultItemProps: { quote: '', author: '' },
    },
  },
  defaultProps: { title: 'Cas clients récents', testimonials: [] },
  render: Testimonials,
};
